export type Appearance = 'system' | 'light' | 'dark';
export function readAppearance(): Appearance {
  try { const value = localStorage.getItem('steos:appearance'); return value === 'light' || value === 'dark' ? value : 'system'; }
  catch { return 'system'; }
}
export function applyAppearance(value = readAppearance()) {
  if (value === 'system') document.documentElement.removeAttribute('data-theme');
  else document.documentElement.dataset.theme = value;
}
export function saveAppearance(value: Appearance) {
  localStorage.setItem('steos:appearance', value); applyAppearance(value);
}
